import cn from "classnames"
import parse from "html-react-parser"
import { DynamicHeadline } from "../../DynamicHeadline"
import Image from "../../Image"
import Section, { parseColors } from "../../Section"
import LinkButton from "../../ui/LinkButton"
import styles from "./Grid.module.scss"

const Grid = ({ data = {}, content, colors }) => {
  const {
    list,
    dynamic_headline: dynamicHeadline,
    headline_appearance: headlineAppearance,
    headline_type: headlineType,
    numbered_list: numberedList,
    versatz: offset,
    list_text: listText,
    list_type,
    ankerslug,
  } = data

  const { accent } = parseColors({ colors })

  const numberColor = ["berry", "black", "grey"].includes(accent.name)
    ? "white"
    : "black"

  const ListType = numberedList ? "ol" : "ul"
  const isIconGrid = list_type?.value === "icon-grid"

  return (
    <Section
      sectionSpacing={{
        top: data?.section_padding_top?.value || null,
        bottom: data?.section_padding_bottom?.value || null,
      }}
      colors={colors}
      id={ankerslug}
      className={cn(styles.listWrapper, {
        [styles.iconGrid]: isIconGrid,
        [styles[`listWrapper--${content.locale}`]]: content.locale,
      })}
    >
      {dynamicHeadline && (
        <DynamicHeadline
          headlineType={headlineType.value}
          headlineAppearance={headlineAppearance.value}
          className={`${styles.listHeadline}`}
        >
          {dynamicHeadline}
        </DynamicHeadline>
      )}
      {listText && <div className={styles.listText}>{parse(listText)}</div>}
      <ListType className={cn(styles.list, { [styles.offset]: offset })}>
        {list.map((listItem, i) => {
          const { list_image: image } = listItem

          return (
            <li className={styles.listItem} key={i}>
              {image && (
                <div className={styles.image}>
                  <Image
                    src={image.permalink}
                    width={image.width}
                    height={image.height}
                    alt={image?.alt}
                    sizes="(max-width: 767px) 100vw, 50vw"
                  />
                </div>
              )}
              <div
                className={styles.graphic}
                style={{ backgroundColor: accent.color, color: numberColor }}
              >
                {numberedList && <span>{i + 1}</span>}
              </div>
              <div className={styles.textWrapper}>
                <DynamicHeadline
                  headlineType={listItem.headline_type.value}
                  headlineAppearance={listItem.headline_appearance.value}
                  className={styles.listItemHeadline}
                >
                  {listItem.dynamic_headline}
                </DynamicHeadline>
                <div className={styles.text}>
                  {listItem.listElementText && parse(listItem.listElementText)}
                  <LinkButton
                    data={listItem}
                    aria-label={
                      "Zur Case Study von " + listItem.dynamic_headline
                    }
                  />
                </div>
              </div>
            </li>
          )
        })}
      </ListType>
    </Section>
  )
}

export default Grid
